import { render, staticRenderFns } from "./login.vue?vue&type=template&id=6efd460b&"
import script from "./login.vue?vue&type=script&lang=js&"
export * from "./login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QImg,QInput,QIcon,QBtn} from 'quasar'
component.options.components = Object.assign({QImg,QInput,QIcon,QBtn}, component.options.components || {})
